export enum StepType { Question = "Question", Answer = "Answer", Result = "Result" }